import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { absolute, join_paths, url_param } from "./utils/paths";
import {
	INSUFFICIENT_PERMISSIONS,
	LOGGED_OUT,
	OAUTH_CALLBACK,
	WOPI_FILE_PAGE,
	EMAIL_VERIFIED
} from "./urls";
import { PageLoading } from "./components/common/PageLoading";

const UserDataWrapper = React.lazy(() => import("./components/common/wrappers/UserDataWrapper"));

const InsufficientPermissionsPage = React.lazy(
	() => import("./components/views/insufficientPermissions/InsufficientPermissionsPage.tsx")
);

const LoggedOutView = React.lazy(() => import("./components/views/logOut/LoggedOutView"));

const OAuthCallbackView = React.lazy(
	() => import("./components/views/oAuthCallback/OAuthCallbackView")
);

const WopiFilePage = React.lazy(() => import("./components/views/documents/wopi/WopiFilePage"));

const EmailVerifiedView = React.lazy(
	() => import("./components/views/emailVerified/EmailVerifiedPage")
);

export const AavoRoutes = () => {
	return (
		<Routes>
			<Route
				path={absolute(LOGGED_OUT)}
				element={
					<Suspense fallback={<PageLoading />}>
						<LoggedOutView />
					</Suspense>
				}
			/>
			<Route
				path={absolute(INSUFFICIENT_PERMISSIONS)}
				element={
					<Suspense fallback={<PageLoading />}>
						<InsufficientPermissionsPage />
					</Suspense>
				}
			/>
			<Route
				path={absolute(OAUTH_CALLBACK)}
				element={
					<Suspense fallback={<PageLoading />}>
						<OAuthCallbackView />
					</Suspense>
				}
			/>
			<Route
				path={join_paths([WOPI_FILE_PAGE, url_param("action"), url_param("fileId")])}
				element={
					<Suspense fallback={<PageLoading />}>
						<WopiFilePage />
					</Suspense>
				}
			/>
			<Route
				path={absolute(EMAIL_VERIFIED)}
				element={
					<Suspense fallback={<PageLoading />}>
						<EmailVerifiedView />
					</Suspense>
				}
			/>
			<Route
				path={"*"}
				element={
					<Suspense fallback={<PageLoading />}>
						<UserDataWrapper />
					</Suspense>
				}
			/>
		</Routes>
	);
};
